<template>
  <div class="p-h-detail" :class="{ 'p-h-detail--max_width': maxWidth }">
    <div class="p-h-detail__header">
      <div
        v-if="image === false"
        class="p-h-detail__header__image p-h-detail__header__no-image"
        :class="roundedClassName"
      ></div>
      <div class="p-h-detail__header__image" :class="roundedClassName">
        <slot name="image" />
      </div>
    </div>

    <div class="p-h-detail__body">
      <div class="p-h-detail__body__inner">
        <slot name="header" />
        <slot name="body" />
      </div>

      <div class="p-h-detail__body__point">
        <div class="p-h-detail-point">
          <PointNotation
            :point="usagePoint.point"
            :sign-is-exists="true"
            :sign="usagePoint.sign"
            :font-size="pointStyle.fontSize"
            :icon-size="pointStyle.iconSize"
          />
          <slot name="points" />
          <div v-if="$slots.label" class="p-h-detail__point__label">
            <slot name="label" />
          </div>
          <slot name="point" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import PointNotation from "@/common/components/atoms/PointNotation.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    image: { type: [String, Boolean], default: false },
    roundedImage: { type: Boolean, default: false },
    usagePoint: { type: Object, default: () => ({}) },
    maxWidth: { type: Boolean, default: true }
  },
  components: {
    PointNotation
  }
})
export default class TheHDetail extends Vue {
  image!: string | boolean;
  roundedImage!: boolean;
  usagePoint: any;
  maxWidth!: boolean;

  get isSp() {
    return globals?.isSpScreenWidth;
  }

  get colorCode() {
    return commons?.colorCode;
  }

  get pointStyle() {
    if (this.isSp) {
      return {
        fontSize: 32,
        iconSize: 24
      };
    } else {
      return {
        fontSize: 44,
        iconSize: 32
      };
    }
  }

  get roundedClassName() {
    const { roundedImage } = this;
    const className = "p-h-detail__header__image--rounded";
    const resultClassName = roundedImage ? className : "";
    return resultClassName;
  }
}
</script>

<style lang="scss" scoped>
.p-h-detail {
  @include pc {
    display: flex;
  }
  position: relative;

  &--max_width &__body__inner {
    max-width: rem(488);
  }

  &--max_width &__body__point {
    max-width: rem(488);
  }

  &__header {
    @include pc {
    }
    display: flex;

    &__image {
      @include pc {
        width: rem(138);
        min-width: rem(138);
        height: rem(138);
      }
      @include sp {
        width: rem(72);
        min-width: rem(72);
        height: rem(72);
      }
      display: block;

      &--rounded {
        border-radius: 50%;
        overflow: hidden;
      }

      img {
        @include pc {
          @include object-fit("cover");
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }

    &__no-image {
      background-color: $customize-yellow;
    }
  }

  &__body {
    @include pc {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
    }
    @include sp {
      margin-top: rem(16);
    }

    &__inner {
      @include pc {
        min-width: rem(414);
        margin-bottom: rem(20);
        padding-left: 1rem;
        flex-grow: 1;
      }
    }

    &__point {
      @include pc {
        width: rem(232 + 48);
        min-width: rem(232 + 48);
        padding-left: 4rem;
        flex-grow: 1;
      }
    }
  }
}

.p-h-detail-point {
  @include pc {
    width: 100%;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  @include sp {
    margin-top: rem(20);
    padding-top: rem(20);
    border-top: px(1) solid $common-gray-border;
  }

  &__label {
    margin-bottom: rem(16);
  }
}
</style>
